import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GungBase } from 'gung-standard';
import { first, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefSystemSettingsService {
  public colorMap: any;

  constructor(private http: HttpClient) {}

  public initColorMap(): Observable<any> {
    const url = `json/system/GUNG`;
    return this.http.get<GungBase>(url).pipe(
      first(),
      tap(data => {
        console.log(this);
        this.colorMap = data.extra.statusCodeToColorMap || {};
        console.log('RefSystemSettingsService colorMap', this.colorMap);
      })
    );
  }
}
